export function COUNTRIES_BY_NAME() {
    return {
        "Andorra": {
            "lat": 42.546245,
            "lon": 1.601554,
            "code": "AD"
        },
        "United Arab Emirates": {
            "lat": 21.824076,
            "lon": 55.847818,
            "code": "AE"
        },
        "Afghanistan": {
            "lat": 33.93911,
            "lon": 67.709953,
            "code": "AF"
        },
        "Antigua and Barbuda": {
            "lat": 17.060816,
            "lon": -61.796428,
            "code": "AG"
        },
        "Anguilla": {
            "lat": 18.220554,
            "lon": -63.068615,
            "code": "AI"
        },
        "Albania": {
            "lat": 41.153332,
            "lon": 20.168331,
            "code": "AL"
        },
        "Armenia": {
            "lat": 40.069099,
            "lon": 45.038189,
            "code": "AM"
        },
        "Netherlands Antilles": {
            "lat": 12.226079,
            "lon": -69.060087,
            "code": "AN"
        },
        "Angola": {
            "lat": -15.202692,
            "lon": 17.873887,
            "code": "AO"
        },
        "Antarctica": {
            "lat": -75.250973,
            "lon": -0.071389,
            "code": "AQ"
        },
        "Argentina": {
            "lat": -38.416097,
            "lon": -66.616672,
            "code": "AR"
        },
        "American Samoa": {
            "lat": -14.270972,
            "lon": -170.132217,
            "code": "AS"
        },
        "Austria": {
            "lat": 47.516231,
            "lon": 14.550072,
            "code": "AT"
        },
        "Australia": {
            "lat": -30.274398,
            "lon": 140.775136,
            "code": "AU"
        },
        "Aruba": {
            "lat": 12.52111,
            "lon": -69.968338,
            "code": "AW"
        },
        "Azerbaijan": {
            "lat": 40.143105,
            "lon": 47.576927,
            "code": "AZ"
        },
        "Bosnia and Herzegovina": {
            "lat": 43.915886,
            "lon": 17.679076,
            "code": "BA"
        },
        "Barbados": {
            "lat": 13.193887,
            "lon": -59.543198,
            "code": "BB"
        },
        "Bangladesh": {
            "lat": 23.684994,
            "lon": 90.356331,
            "code": "BD"
        },
        "Belgium": {
            "lat": 50.503887,
            "lon": 4.469936,
            "code": "BE"
        },
        "Burkina Faso": {
            "lat": 12.238333,
            "lon": -1.561593,
            "code": "BF"
        },
        "Bulgaria": {
            "lat": 42.733883,
            "lon": 25.48583,
            "code": "BG"
        },
        "Bahrain": {
            "lat": 25.930414,
            "lon": 50.637772,
            "code": "BH"
        },
        "Burundi": {
            "lat": -3.373056,
            "lon": 29.918886,
            "code": "BI"
        },
        "Benin": {
            "lat": 9.30769,
            "lon": 2.315834,
            "code": "BJ"
        },
        "Bermuda": {
            "lat": 32.321384,
            "lon": -64.75737,
            "code": "BM"
        },
        "Brunei": {
            "lat": 4.535277,
            "lon": 114.727669,
            "code": "BN"
        },
        "Bolivia": {
            "lat": -16.290154,
            "lon": -63.588653,
            "code": "BO"
        },
        "Brazil": {
            "lat": -14.235004,
            "lon": -51.92528,
            "code": "BR"
        },
        "Bahamas": {
            "lat": 25.03428,
            "lon": -77.39628,
            "code": "BS"
        },
        "Bhutan": {
            "lat": 27.514162,
            "lon": 90.433601,
            "code": "BT"
        },
        "Bouvet Island": {
            "lat": -54.423199,
            "lon": 3.413194,
            "code": "BV"
        },
        "Botswana": {
            "lat": -22.328474,
            "lon": 24.684866,
            "code": "BW"
        },
        "Belarus": {
            "lat": 53.709807,
            "lon": 27.953389,
            "code": "BY"
        },
        "Belize": {
            "lat": 17.189877,
            "lon": -88.49765,
            "code": "BZ"
        },
        "Canada": {
            "lat": 56.130366,
            "lon": -106.346771,
            "code": "CA"
        },
        "Cocos [Keeling] Islands": {
            "lat": -12.164165,
            "lon": 96.870956,
            "code": "CC"
        },
        "Congo [DRC]": {
            "lat": -4.038333,
            "lon": 21.758664,
            "code": "CD"
        },
        "Central African Republic": {
            "lat": 6.611111,
            "lon": 20.939444,
            "code": "CF"
        },
        "Congo [Republic]": {
            "lat": -0.228021,
            "lon": 15.827659,
            "code": "CG"
        },
        "Switzerland": {
            "lat": 46.818188,
            "lon": 8.227512,
            "code": "CH"
        },
        "Côte d'Ivoire": {
            "lat": 7.539989,
            "lon": -5.54708,
            "code": "CI"
        },
        "Cook Islands": {
            "lat": -21.236736,
            "lon": -159.777671,
            "code": "CK"
        },
        "Chile": {
            "lat": -35.675147,
            "lon": -71.542969,
            "code": "CL"
        },
        "Cameroon": {
            "lat": 7.369722,
            "lon": 12.354722,
            "code": "CM"
        },
        "China": {
            "lat": 35.86166,
            "lon": 104.195397,
            "code": "CN"
        },
        "Colombia": {
            "lat": 4.570868,
            "lon": -74.297333,
            "code": "CO"
        },
        "Costa Rica": {
            "lat": 9.748917,
            "lon": -83.753428,
            "code": "CR"
        },
        "Cuba": {
            "lat": 21.521757,
            "lon": -77.781167,
            "code": "CU"
        },
        "Cape Verde": {
            "lat": 16.002082,
            "lon": -24.013197,
            "code": "CV"
        },
        "Christmas Island": {
            "lat": -10.447525,
            "lon": 105.690449,
            "code": "CX"
        },
        "Cyprus": {
            "lat": 34.026413,
            "lon": 33.429859,
            "code": "CY"
        },
        "Czechia": {
            "lat": 49.817492,
            "lon": 15.472962,
            "code": "CZ"
        },
        "Germany": {
            "lat": 51.165691,
            "lon": 10.451526,
            "code": "DE"
        },
        "Djibouti": {
            "lat": 11.825138,
            "lon": 42.590275,
            "code": "DJ"
        },
        "Denmark": {
            "lat": 56.26392,
            "lon": 9.501785,
            "code": "DK"
        },
        "Dominica": {
            "lat": 15.414999,
            "lon": -61.370976,
            "code": "DM"
        },
        "Dominican Republic": {
            "lat": 18.735693,
            "lon": -70.162651,
            "code": "DO"
        },
        "Algeria": {
            "lat": 28.033886,
            "lon": 1.659626,
            "code": "DZ"
        },
        "Ecuador": {
            "lat": -3.831239,
            "lon": -80.183406,
            "code": "EC"
        },
        "Estonia": {
            "lat": 58.595272,
            "lon": 25.013607,
            "code": "EE"
        },
        "Egypt": {
            "lat": 26.820553,
            "lon": 30.802498,
            "code": "EG"
        },
        "Western Sahara": {
            "lat": 24.215527,
            "lon": -12.885834,
            "code": "EH"
        },
        "Eritrea": {
            "lat": 15.179384,
            "lon": 39.782334,
            "code": "ER"
        },
        "Spain": {
            "lat": 40.463667,
            "lon": -3.74922,
            "code": "ES"
        },
        "Ethiopia": {
            "lat": 9.145,
            "lon": 40.489673,
            "code": "ET"
        },
        "Finland": {
            "lat": 61.92411,
            "lon": 25.748151,
            "code": "FI"
        },
        "Fiji": {
            "lat": -16.578193,
            "lon": 179.414413,
            "code": "FJ"
        },
        "Falkland Islands [Islas Malvinas]": {
            "lat": -51.796253,
            "lon": -59.523613,
            "code": "FK"
        },
        "Micronesia": {
            "lat": 7.425554,
            "lon": 150.550812,
            "code": "FM"
        },
        "Faroe Islands": {
            "lat": 61.892635,
            "lon": -6.911806,
            "code": "FO"
        },
        "France": {
            "lat": 46.227638,
            "lon": 2.213749,
            "code": "FR"
        },
        "Gabon": {
            "lat": -0.803689,
            "lon": 11.609444,
            "code": "GA"
        },
        "United Kingdom": {
            "lat": 55.378051,
            "lon": -3.435973,
            "code": "GB"
        },
        "Grenada": {
            "lat": 12.262776,
            "lon": -61.604171,
            "code": "GD"
        },
        "Georgia": {
            "lat": 41.315407,
            "lon": 43.356892,
            "code": "GE"
        },
        "French Guiana": {
            "lat": 3.933889,
            "lon": -53.125782,
            "code": "GF"
        },
        "Guernsey": {
            "lat": 49.465691,
            "lon": -2.585278,
            "code": "GG"
        },
        "Ghana": {
            "lat": 5.946527,
            "lon": -1.023194,
            "code": "GH"
        },
        "Gibraltar": {
            "lat": 36.137741,
            "lon": -5.345374,
            "code": "GI"
        },
        "Greenland": {
            "lat": 71.706936,
            "lon": -42.604303,
            "code": "GL"
        },
        "Gambia": {
            "lat": 13.443182,
            "lon": -15.310139,
            "code": "GM"
        },
        "Guinea": {
            "lat": 9.945587,
            "lon": -9.696645,
            "code": "GN"
        },
        "Guadeloupe": {
            "lat": 16.995971,
            "lon": -62.067641,
            "code": "GP"
        },
        "Equatorial Guinea": {
            "lat": 1.650801,
            "lon": 10.267895,
            "code": "GQ"
        },
        "Greece": {
            "lat": 39.074208,
            "lon": 21.824312,
            "code": "GR"
        },
        "South Georgia and the South Sandwich Islands": {
            "lat": -54.429579,
            "lon": -36.587909,
            "code": "GS"
        },
        "Guatemala": {
            "lat": 15.783471,
            "lon": -90.230759,
            "code": "GT"
        },
        "Guam": {
            "lat": 13.444304,
            "lon": 144.793731,
            "code": "GU"
        },
        "Guinea-Bissau": {
            "lat": 11.803749,
            "lon": -15.180413,
            "code": "GW"
        },
        "Guyana": {
            "lat": 4.860416,
            "lon": -58.93018,
            "code": "GY"
        },
        "Gaza Strip": {
            "lat": 31.354676,
            "lon": 34.308825,
            "code": "GZ"
        },
        "Hong Kong": {
            "lat": 20.396428,
            "lon": 115.109497,
            "code": "HK"
        },
        "Heard Island and McDonald Islands": {
            "lat": -53.08181,
            "lon": 73.504158,
            "code": "HM"
        },
        "Honduras": {
            "lat": 15.199999,
            "lon": -86.241905,
            "code": "HN"
        },
        "Croatia": {
            "lat": 45.1,
            "lon": 16.2,
            "code": "HR"
        },
        "Haiti": {
            "lat": 18.971187,
            "lon": -72.285215,
            "code": "HT"
        },
        "Hungary": {
            "lat": 47.162494,
            "lon": 19.503304,
            "code": "HU"
        },
        "Indonesia": {
            "lat": -3.789275,
            "lon": 115.921327,
            "code": "ID"
        },
        "Ireland": {
            "lat": 53.41291,
            "lon": -8.24389,
            "code": "IE"
        },
        "Israel": {
            "lat": 29.546051,
            "lon": 35.651612,
            "code": "IL"
        },
        "Isle of Man": {
            "lat": 54.236107,
            "lon": -4.548056,
            "code": "IM"
        },
        "India": {
            "lat": 20.593684,
            "lon": 78.96288,
            "code": "IN"
        },
        "British Indian Ocean Territory": {
            "lat": -6.343194,
            "lon": 71.876519,
            "code": "IO"
        },
        "Iraq": {
            "lat": 33.223191,
            "lon": 43.679291,
            "code": "IQ"
        },
        "Iran": {
            "lat": 32.427908,
            "lon": 53.688046,
            "code": "IR"
        },
        "Iceland": {
            "lat": 64.963051,
            "lon": -19.020835,
            "code": "IS"
        },
        "Italy": {
            "lat": 41.87194,
            "lon": 13.56738,
            "code": "IT"
        },
        "Jersey": {
            "lat": 49.214439,
            "lon": -2.13125,
            "code": "JE"
        },
        "Jamaica": {
            "lat": 18.109581,
            "lon": -77.297508,
            "code": "JM"
        },
        "Jordan": {
            "lat": 30.585164,
            "lon": 36.238414,
            "code": "JO"
        },
        "Japan": {
            "lat": 36.204824,
            "lon": 142.252924,
            "code": "JP"
        },
        "Kenya": {
            "lat": -0.023559,
            "lon": 37.906193,
            "code": "KE"
        },
        "Kyrgyzstan": {
            "lat": 41.20438,
            "lon": 74.766098,
            "code": "KG"
        },
        "Cambodia": {
            "lat": 12.565679,
            "lon": 104.990963,
            "code": "KH"
        },
        "Kiribati": {
            "lat": -3.370417,
            "lon": -168.734039,
            "code": "KI"
        },
        "Comoros": {
            "lat": -11.875001,
            "lon": 43.872219,
            "code": "KM"
        },
        "Saint Kitts and Nevis": {
            "lat": 17.357822,
            "lon": -62.782998,
            "code": "KN"
        },
        "North Korea": {
            "lat": 40.339852,
            "lon": 127.510093,
            "code": "KP"
        },
        "South Korea": {
            "lat": 35.907757,
            "lon": 130.766922,
            "code": "KR"
        },
        "Kuwait": {
            "lat": 29.31166,
            "lon": 47.481766,
            "code": "KW"
        },
        "Cayman Islands": {
            "lat": 19.513469,
            "lon": -80.566956,
            "code": "KY"
        },
        "Kazakhstan": {
            "lat": 48.019573,
            "lon": 66.923684,
            "code": "KZ"
        },
        "Laos": {
            "lat": 19.85627,
            "lon": 102.495496,
            "code": "LA"
        },
        "Lebanon": {
            "lat": 33.854721,
            "lon": 35.862285,
            "code": "LB"
        },
        "Saint Lucia": {
            "lat": 13.909444,
            "lon": -60.978893,
            "code": "LC"
        },
        "Liechtenstein": {
            "lat": 47.166,
            "lon": 9.555373,
            "code": "LI"
        },
        "Sri Lanka": {
            "lat": 7.873054,
            "lon": 80.771797,
            "code": "LK"
        },
        "Liberia": {
            "lat": 6.428055,
            "lon": -9.429499,
            "code": "LR"
        },
        "Lesotho": {
            "lat": -29.609988,
            "lon": 28.233608,
            "code": "LS"
        },
        "Lithuania": {
            "lat": 55.169438,
            "lon": 23.881275,
            "code": "LT"
        },
        "Luxembourg": {
            "lat": 49.815273,
            "lon": 6.129583,
            "code": "LU"
        },
        "Latvia": {
            "lat": 56.879635,
            "lon": 24.603189,
            "code": "LV"
        },
        "Libya": {
            "lat": 26.3351,
            "lon": 17.228331,
            "code": "LY"
        },
        "Morocco": {
            "lat": 31.791702,
            "lon": -7.09262,
            "code": "MA"
        },
        "Monaco": {
            "lat": 43.750298,
            "lon": 7.412841,
            "code": "MC"
        },
        "Moldova": {
            "lat": 47.411631,
            "lon": 28.369885,
            "code": "MD"
        },
        "Montenegro": {
            "lat": 42.708678,
            "lon": 19.37439,
            "code": "ME"
        },
        "Madagascar": {
            "lat": -18.766947,
            "lon": 46.869107,
            "code": "MG"
        },
        "Marshall Islands": {
            "lat": 7.131474,
            "lon": 171.184478,
            "code": "MH"
        },
        "Macedonia [FYROM]": {
            "lat": 41.608635,
            "lon": 21.745275,
            "code": "MK"
        },
        "Mali": {
            "lat": 17.570692,
            "lon": -3.996166,
            "code": "ML"
        },
        "Myanmar [Burma]": {
            "lat": 21.913965,
            "lon": 95.956223,
            "code": "MM"
        },
        "Mongolia": {
            "lat": 46.862496,
            "lon": 103.846656,
            "code": "MN"
        },
        "Macau": {
            "lat": 22.198745,
            "lon": 113.543873,
            "code": "MO"
        },
        "Northern Mariana Islands": {
            "lat": 17.33083,
            "lon": 145.38469,
            "code": "MP"
        },
        "Martinique": {
            "lat": 14.641528,
            "lon": -61.024174,
            "code": "MQ"
        },
        "Mauritania": {
            "lat": 21.00789,
            "lon": -10.940835,
            "code": "MR"
        },
        "Montserrat": {
            "lat": 16.742498,
            "lon": -62.187366,
            "code": "MS"
        },
        "Malta": {
            "lat": 36.937496,
            "lon": 14.375416,
            "code": "MT"
        },
        "Mauritius": {
            "lat": -20.348404,
            "lon": 57.552152,
            "code": "MU"
        },
        "Maldives": {
            "lat": 3.202778,
            "lon": 73.22068,
            "code": "MV"
        },
        "Malawi": {
            "lat": -13.254308,
            "lon": 34.301525,
            "code": "MW"
        },
        "Mexico": {
            "lat": 23.634501,
            "lon": -102.552784,
            "code": "MX"
        },
        "Malaysia": {
            "lat": 2.210484,
            "lon": 103.975766,
            "code": "MY"
        },
        "Mozambique": {
            "lat": -18.665695,
            "lon": 35.529562,
            "code": "MZ"
        },
        "Namibia": {
            "lat": -22.95764,
            "lon": 18.49041,
            "code": "NA"
        },
        "New Caledonia": {
            "lat": -20.904305,
            "lon": 165.618042,
            "code": "NC"
        },
        "Niger": {
            "lat": 17.607789,
            "lon": 8.081666,
            "code": "NE"
        },
        "Norfolk Island": {
            "lat": -29.040835,
            "lon": 167.954712,
            "code": "NF"
        },
        "Nigeria": {
            "lat": 9.081999,
            "lon": 8.675277,
            "code": "NG"
        },
        "Nicaragua": {
            "lat": 12.865416,
            "lon": -85.207229,
            "code": "NI"
        },
        "Netherlands": {
            "lat": 52.132633,
            "lon": 5.291266,
            "code": "NL"
        },
        "Norway": {
            "lat": 60.472024,
            "lon": 8.468946,
            "code": "NO"
        },
        "Nepal": {
            "lat": 28.394857,
            "lon": 84.124008,
            "code": "NP"
        },
        "Nauru": {
            "lat": -0.522778,
            "lon": 166.931503,
            "code": "NR"
        },
        "Niue": {
            "lat": -19.054445,
            "lon": -169.867233,
            "code": "NU"
        },
        "New Zealand": {
            "lat": -45.900557,
            "lon": 180.885971,
            "code": "NZ"
        },
        "Oman": {
            "lat": 21.512583,
            "lon": 55.923255,
            "code": "OM"
        },
        "Panama": {
            "lat": 6.537981,
            "lon": -80.782127,
            "code": "PA"
        },
        "Peru": {
            "lat": -12.189967,
            "lon": -78.015152,
            "code": "PE"
        },
        "French Polynesia": {
            "lat": -17.679742,
            "lon": -149.406843,
            "code": "PF"
        },
        "Papua New Guinea": {
            "lat": -6.314993,
            "lon": 143.95555,
            "code": "PG"
        },
        "Philippines": {
            "lat": 12.879721,
            "lon": 123.774017,
            "code": "PH"
        },
        "Pakistan": {
            "lat": 30.375321,
            "lon": 69.345116,
            "code": "PK"
        },
        "Poland": {
            "lat": 51.919438,
            "lon": 19.145136,
            "code": "PL"
        },
        "Saint Pierre and Miquelon": {
            "lat": 46.941936,
            "lon": -56.27111,
            "code": "PM"
        },
        "Pitcairn Islands": {
            "lat": -24.703615,
            "lon": -127.439308,
            "code": "PN"
        },
        "Puerto Rico": {
            "lat": 16.220833,
            "lon": -66.590149,
            "code": "PR"
        },
        "Palestinian Territories": {
            "lat": 31.952162,
            "lon": 35.233154,
            "code": "PS"
        },
        "Portugal": {
            "lat": 39.399872,
            "lon": -8.224454,
            "code": "PT"
        },
        "Palau": {
            "lat": 7.51498,
            "lon": 134.58252,
            "code": "PW"
        },
        "Paraguay": {
            "lat": -23.442503,
            "lon": -58.443832,
            "code": "PY"
        },
        "Qatar": {
            "lat": 25.354826,
            "lon": 51.183884,
            "code": "QA"
        },
        "Réunion": {
            "lat": -25.115141,
            "lon": 55.536384,
            "code": "RE"
        },
        "Romania": {
            "lat": 45.943161,
            "lon": 24.96676,
            "code": "RO"
        },
        "Serbia": {
            "lat": 44.016521,
            "lon": 21.005859,
            "code": "RS"
        },
        "Russia": {
            "lat": 61.52401,
            "lon": 105.318756,
            "code": "RU"
        },
        "Rwanda": {
            "lat": -1.940278,
            "lon": 29.873888,
            "code": "RW"
        },
        "Saudi Arabia": {
            "lat": 23.885942,
            "lon": 45.079162,
            "code": "SA"
        },
        "Solomon Islands": {
            "lat": -9.64571,
            "lon": 160.156194,
            "code": "SB"
        },
        "Seychelles": {
            "lat": -4.679574,
            "lon": 55.491977,
            "code": "SC"
        },
        "Sudan": {
            "lat": 12.862807,
            "lon": 30.217636,
            "code": "SD"
        },
        "Sweden": {
            "lat": 60.128161,
            "lon": 18.643501,
            "code": "SE"
        },
        "Singapore": {
            "lat": -1.352083,
            "lon": 105.819836,
            "code": "SG"
        },
        "Saint Helena": {
            "lat": -24.143474,
            "lon": -10.030696,
            "code": "SH"
        },
        "Slovenia": {
            "lat": 45.551241,
            "lon": 14.995463,
            "code": "SI"
        },
        "Svalbard and Jan Mayen": {
            "lat": 77.553604,
            "lon": 23.670272,
            "code": "SJ"
        },
        "Slovakia": {
            "lat": 48.669026,
            "lon": 19.699024,
            "code": "SK"
        },
        "Sierra Leone": {
            "lat": 8.460555,
            "lon": -11.779889,
            "code": "SL"
        },
        "San Marino": {
            "lat": 43.94236,
            "lon": 12.457777,
            "code": "SM"
        },
        "Senegal": {
            "lat": 14.497401,
            "lon": -14.452362,
            "code": "SN"
        },
        "Somalia": {
            "lat": 5.152149,
            "lon": 46.199616,
            "code": "SO"
        },
        "Suriname": {
            "lat": 3.919305,
            "lon": -56.027783,
            "code": "SR"
        },
        "São Tomé and Príncipe": {
            "lat": 0.18636,
            "lon": 6.613081,
            "code": "ST"
        },
        "El Salvador": {
            "lat": 13.794185,
            "lon": -88.89653,
            "code": "SV"
        },
        "Syria": {
            "lat": 34.802075,
            "lon": 38.996815,
            "code": "SY"
        },
        "Swaziland": {
            "lat": -26.522503,
            "lon": 31.465866,
            "code": "SZ"
        },
        "Turks and Caicos Islands": {
            "lat": 21.694025,
            "lon": -71.797928,
            "code": "TC"
        },
        "Chad": {
            "lat": 15.454166,
            "lon": 18.732207,
            "code": "TD"
        },
        "French Southern Territories": {
            "lat": -49.280366,
            "lon": 69.348557,
            "code": "TF"
        },
        "Togo": {
            "lat": 8.619543,
            "lon": 0.824782,
            "code": "TG"
        },
        "Thailand": {
            "lat": 13.870032,
            "lon": 103.992541,
            "code": "TH"
        },
        "Tajikistan": {
            "lat": 38.861034,
            "lon": 71.276093,
            "code": "TJ"
        },
        "Tokelau": {
            "lat": -8.967363,
            "lon": -171.855881,
            "code": "TK"
        },
        "Timor-Leste": {
            "lat": -8.874217,
            "lon": 125.727539,
            "code": "TL"
        },
        "Turkmenistan": {
            "lat": 38.969719,
            "lon": 59.556278,
            "code": "TM"
        },
        "Tunisia": {
            "lat": 33.886917,
            "lon": 9.537499,
            "code": "TN"
        },
        "Tonga": {
            "lat": -21.178986,
            "lon": -175.198242,
            "code": "TO"
        },
        "Turkey": {
            "lat": 38.963745,
            "lon": 35.243322,
            "code": "TR"
        },
        "Trinidad and Tobago": {
            "lat": 8.691803,
            "lon": -61.222503,
            "code": "TT"
        },
        "Tuvalu": {
            "lat": -7.109535,
            "lon": 177.64933,
            "code": "TV"
        },
        "Taiwan": {
            "lat": 21.69781,
            "lon": 123.460515,
            "code": "TW"
        },
        "Tanzania": {
            "lat": -6.369028,
            "lon": 34.888822,
            "code": "TZ"
        },
        "Ukraine": {
            "lat": 48.379433,
            "lon": 31.16558,
            "code": "UA"
        },
        "Uganda": {
            "lat": 1.373333,
            "lon": 32.290275,
            "code": "UG"
        },
        "U.S. Minor Outlying Islands": {
            "lat": "",
            "lon": "",
            "code": "UM"
        },
        "United States": {
            "lat": 37.09024,
            "lon": -95.712891,
            "code": "US"
        },
        "Uruguay": {
            "lat": -32.522779,
            "lon": -55.765835,
            "code": "UY"
        },
        "Uzbekistan": {
            "lat": 41.377491,
            "lon": 64.585262,
            "code": "UZ"
        },
        "Vatican City": {
            "lat": 41.902916,
            "lon": 12.453389,
            "code": "VA"
        },
        "Saint Vincent and the Grenadines": {
            "lat": 12.984305,
            "lon": -61.287228,
            "code": "VC"
        },
        "Venezuela": {
            "lat": 6.42375,
            "lon": -66.58973,
            "code": "VE"
        },
        "British Virgin Islands": {
            "lat": 18.420695,
            "lon": -64.639968,
            "code": "VG"
        },
        "U.S. Virgin Islands": {
            "lat": 18.335765,
            "lon": -64.896335,
            "code": "VI"
        },
        "Vietnam": {
            "lat": 11.058324,
            "lon": 110.277199,
            "code": "VN"
        },
        "Vanuatu": {
            "lat": -15.376706,
            "lon": 166.959158,
            "code": "VU"
        },
        "Wallis and Futuna": {
            "lat": -13.768752,
            "lon": -177.156097,
            "code": "WF"
        },
        "Samoa": {
            "lat": -13.759029,
            "lon": -172.104629,
            "code": "WS"
        },
        "Kosovo": {
            "lat": 42.602636,
            "lon": 20.902977,
            "code": "XK"
        },
        "Yemen": {
            "lat": 15.552727,
            "lon": 48.516388,
            "code": "YE"
        },
        "Mayotte": {
            "lat": -12.8275,
            "lon": 45.166244,
            "code": "YT"
        },
        "South Africa": {
            "lat": -34.559482,
            "lon": 25.937506,
            "code": "ZA"
        },
        "Zambia": {
            "lat": -13.133897,
            "lon": 27.849332,
            "code": "ZM"
        },
        "Zimbabwe": {
            "lat": -19.015438,
            "lon": 29.154857,
            "code": "ZW"
        }
    }
}
